import type { OnboardingStatus } from '@/lib/onboarding/service';

import {
  clearAllPersistedCacheByPrefix,
  getPersistedCache,
  setPersistedCache,
} from './persistedCache';

const CACHE_VERSION = 1;
const STORAGE_KEY_PREFIX = 'ahoy-cache-onboarding-pipeline-complete-';
const COMPONENT = 'persisted-onboarding-complete';

function isCompletedShape(raw: unknown): raw is true {
  return raw === true;
}

export function getPersistedOnboardingComplete(
  orgId: number | undefined
): boolean | undefined {
  if (orgId === undefined) {
    return undefined;
  }
  return getPersistedCache<true>(
    `${STORAGE_KEY_PREFIX}${orgId}`,
    CACHE_VERSION,
    isCompletedShape,
    COMPONENT
  );
}

export function setPersistedOnboardingComplete(orgId: number): void {
  setPersistedCache(
    `${STORAGE_KEY_PREFIX}${orgId}`,
    true,
    CACHE_VERSION,
    COMPONENT
  );
}

export function clearAllPersistedOnboardingComplete(): void {
  clearAllPersistedCacheByPrefix(STORAGE_KEY_PREFIX, COMPONENT);
}

export const COMPLETED_ONBOARDING_STATUS: OnboardingStatus = {
  onboarding: {
    is_completed: true,
    current_step: 'complete',
    skipped_steps: [],
    completed_at: null,
  },
  services: {
    email: { connected: true, provider: null, email: null },
    calendar: { connected: true, provider: null, email: null },
  },
  enrichment_pending: false,
  steps: [
    {
      step_name: 'complete',
      display_name: 'Complete',
      status: 'completed',
      depends_on: [],
      blocked_by: [],
      started_at: null,
      completed_at: null,
      error_message: '',
      retry_count: 0,
      can_retry: false,
      can_skip: false,
    },
  ],
  pipeline_complete: true,
  steps_completed: 1,
  steps_total: 1,
  orphaned_step_count: 0,
};
